import { GridDataAdapterService } from '@app/shared/grid/services/grid-data-adapter.service';
import { FilterWithMatchingTopicTypeIdOptions, GridTopicFieldRenderer } from '@app/shared/grid/grid-options';
import { CountriesModel } from '@app/pages/main/pages/startup-countries/models/countries.interfaces';
import { SimpleTopic } from '@app/origami-api/utils/topic-utils';
import { LayoutGridState } from '@app/shared/layout/layout-grid/layout-grid';
import { LayoutTreeState } from '@app/shared/layout/layout-tree/layout-tree';
import { LayoutCodingOptions, LayoutState, LayoutViewsWithGridState } from '@app/shared/layout/layout';
import { SSUEssentialDocument } from '@app/origami-api/services/essential-documents.service';
import { LayoutCodingComponentState } from '@app/shared/layout/layout-coding/layout-coding.model';

export namespace SSUDocuments {
  import StateToolbarBtn = CountriesModel.StateToolbarBtn;
  import GetSSUDocumentsViews = SSUEssentialDocument.GetSSUDocumentsViews;
  import GetDocumentByViewOptions = SSUEssentialDocument.GetDocumentByViewOptions;
  export const SSUDocumentsIcon = 'far fa-file';

  export const filterExpanded = 'ssu_d_f_exp';
  export const codingExpanded = 'ssu_d_c_exp';
  export const viewerExpanded = 'ssu_d_v_exp';
  export const viewerPosition = 'ssu_d_v_pos';
  export const documentSelectedItems = 'ssu_c_doc_sel_items';
  export const documentGridVt = 'ssu_docs_grid_vt';
  export const documentPage = 'ssu_c_doc_page';

  export enum SSUDocumentsStatuses {
    Missing,
    Pending = 1,
    Approved,
    Rejected,
  }

  export interface ExtendedGridDataAdapter extends GridDataAdapterService<any, any, any> {
    countRows: number;
    getRequiredDocuments: boolean;
  }

  export type SSUDocumentsActionsInput = LayoutState<
    LayoutTreeState<GetSSUDocumentsViews, any>,
    LayoutGridState<GetDocumentByViewOptions, SimpleTopic>,
    LayoutCodingComponentState<SimpleTopic>,
    LayoutCodingOptions<any, any, SimpleTopic, GetSSUDocumentsViews, SimpleTopic>
  >;

  export type SSUDocumentsModuleState = LayoutViewsWithGridState<
    GetSSUDocumentsViews,
    any,
    any,
    SimpleTopic,
    SimpleTopic
  >;
  export interface SSUDocumentsActionResult {
    cancel: boolean;
    data: SimpleTopic;
  }

  export interface DocumentColumnOptions {
    topicTypes: string;
    columnsFromTopicTypeTopicFields: string;
    topicTypeRenderers: GridTopicFieldRenderer<any, any>[];
    forms?: FilterWithMatchingTopicTypeIdOptions;
  }

  export enum DocumentsLayoutViewType {
    DOCUMENTS_COUNTRY_VIEW = 1,
    DOCUMENTS_IRB_VIEW = 2,
    DOCUMENTS_SITES_VIEW,
    DOCUMENTS_MAIN_VIEW,
    DOCUMENTS_AMENDMENTS_VIEW,
    DOCUMENTS_REG_REVIEW_VIEW,
    DOCUMENTS_SPONSOR_REVIEW_VIEW,
    DOCUMENTS_CHANGE_STATUS_VIEW,
    DOCUMENTS_CART_VIEW,
  }

  export enum SSUEntitiesDocumentsTabs {
    Favorites = 0,
    Required = 1,
    Missing = 2,
    NonRequired = 3,
    AllUploads = 4,
  }

  export enum SSUMaiDocumentsTabs {
    Favorites = -1,
    AllDocuments = 0,
  }

  export enum ESSUActionType {
    Export = 0,
    Other = 1,
  }

  export interface SSUDocumentsCommonActionsParams {
    essentialForId?: string | number;
    essentialFor?: number;
    amendmentProfileId?: number;
    entityName?: string;
    domainTopicId?: number;
    siteId?: number;
    isSiteActivationSpecialist?: boolean;
  }

  export interface DocumentLayoutActionsParams extends SSUDocumentsCommonActionsParams {
    icon?: string;
    text?: string;
    showWhen?: StateToolbarBtn;
    defaultHidden?: boolean;
    activeWhen?: StateToolbarBtn;
    defaultDisable?: boolean;
    alwaysDisable?: boolean;
    isContext?: boolean;
    viewType?: DocumentsLayoutViewType;
  }
}
